import * as Sentry from '@sentry/vue';
import {
  createSentryBeforeSend,
  getAppInformation,
  sentryIgnoreErrors,
} from 'shared/utils';
import type { App } from 'vue';
import type { Router } from 'vue-router';

export function setupSentry(app: App, router: Router) {
  const { VITE_APP_SENTRY_DSN, VITE_APP_ENV } = import.meta.env;

  if (!VITE_APP_SENTRY_DSN) {
    return;
  }

  const { version } = getAppInformation();

  Sentry.init({
    app,
    dsn: VITE_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    release: version,
    environment: VITE_APP_ENV,
    ignoreErrors: sentryIgnoreErrors,
    beforeSend: createSentryBeforeSend(),
    tracesSampleRate: 0.2,
    allowUrls: [/https?:\/\/[\w-]+\.kinnovis\.com\//, window.location.hostname],
    tracePropagationTargets: ['kinnovis.com', /^\//],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
